import { setRequestedVersionAction as setRequestedVersionOperation } from 'editor/src/store/editorModules/addons/slice';

export default setRequestedVersionOperation;
